module.exports = __webpack_public_path__ + "static/media/add-patient.46a16ecf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/add-patient.svg
// module id = 2154
// module chunks = 0